import { ContentPlaceholder, FilePlaceholder } from '@app/components/various/Icons';
import { cn } from '@app/utils/cn';
import { isDefined } from '@app/utils/is';
import { Trans, useTranslation } from 'react-i18next';

interface Props {
  disabled: boolean;
  accept: string[];
}

export const Message = ({ accept, disabled }: Props) => {
  const { t } = useTranslation(['common']);
  const isImageOnly = accept.every(type => type.includes('image/'));
  const acceptedFormats = accept.map(type => type.split('/')[1]?.toUpperCase()).filter(isDefined);

  const disabledTextStyle = { 'text-current': disabled };

  return (
    <div className={cn('pointer-events-none flex flex-col items-center gap-1', { 'text-neutral-80': disabled })}>
      {isImageOnly ?
        <ContentPlaceholder className="-mt-2" />
      : <FilePlaceholder width={24} />}
      <p className={cn('text-neutral-40 body-2', disabledTextStyle)}>
        <Trans t={t} i18nKey="common:click_to_upload">
          <span className={cn('text-neutral-20 underline underline-offset-4', disabledTextStyle)}>Click to upload</span> or drag and drop
          here.
        </Trans>
      </p>
      <p className={cn('text-neutral-60 body-5', disabledTextStyle)}>{t('common:accepted_files', { acceptedFiles: acceptedFormats })}</p>
    </div>
  );
};
